import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { GET_PROVIDER_COUNT } from "../../../api-setup/api-endpoints";

export const fetchProviderCount = async (cookiesData, dispatch) => {
  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
    };

    const response = await POSTAPI(false, GET_PROVIDER_COUNT, null, apiHeaders, requestBody, dispatch);

    if (response?.data?.row_result && Array.isArray(response.data.row_result) && response.data.row_result.length > 0) {
      const providerCount = response.data.row_result[0].provider_count || 0;

      return {
        success: true,
        providerCount: providerCount,
      };
    } else {
      console.error("Failed to fetch provider count:", response?.message || "Invalid response structure");
      return {
        success: false,
        providerCount: 0,
        error: response?.message || "Invalid response structure",
      };
    }
  } catch (error) {
    console.error("Error fetching provider count:", error);
    return {
      success: false,
      providerCount: 0,
      error: error.message,
    };
  }
};
